import React from 'react';

const spinner = (props) => {
  return <div className="loading"></div>;
};

export default spinner;
